/*********************** Custom JS for Boost AI Search & Discovery  ************************/

// Disable Boost's built-in ajax cart so it doesn't conflict with the
// theme's native cart drawer. The theme handles cart open/close itself.
if (typeof boostPFSFilterConfig !== 'undefined' && boostPFSFilterConfig.general) {
  boostPFSFilterConfig.general.enableAjaxCart = false;
  boostPFSFilterConfig.general.showAjaxCartOnAdd = false;
}

// Boost SD v3 app embed CSS sets visibility:hidden on the collection grid
// as part of its SSR pattern. When running the legacy PFS filter instead,
// the v3 JS never reveals the grid. Force it visible after PFS renders.
(function revealBoostGrid() {
  function showGrid() {
    var grid = document.getElementById('main-collection-product-grid');
    if (grid) grid.style.visibility = 'visible';
  }
  document.addEventListener('DOMContentLoaded', showGrid);
  window.addEventListener('load', showGrid);
  // Also listen for Boost PFS custom render events
  document.addEventListener('boost-pfs-filter-rendered', showGrid);
  document.addEventListener('boost-pfs-filter-page-loaded', showGrid);
})();